import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Agitate from './components/Agitate';
import Solution from './components/Solution';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import WhoItsFor from './components/WhoItsFor';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Blog from './components/Blog';
import BlogAdmin from './components/BlogAdmin';
import ChatGuider from './components/ChatGuider';
import { blogService, settingsService } from './lib/firebase';

function App() {
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [posts, setPosts] = useState([]);

  const fetchData = async () => {
    try {
      const postsData = await blogService.getPosts(false);
      setPosts(postsData);
    } catch (err) {
      console.error("Failed to fetch data:", err);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-navy text-white selection:bg-gold/30 selection:text-gold relative">
      <Navbar onLogoClick={() => setIsAdminOpen(true)} />
      
      <main>
        <Hero />
        <Agitate />
        <Solution />
        <HowItWorks />
        <Comparison />
        <WhoItsFor />
        <Pricing />
        <FAQ />
        <Blog posts={posts} />
        <FinalCTA />
      </main>

      <Footer />
      <ChatGuider />
      
      <BlogAdmin 
        isOpen={isAdminOpen} 
        onClose={() => setIsAdminOpen(false)} 
        onRefresh={fetchData}
      />
    </div>
  );
}

export default App;